module.exports = __webpack_public_path__ + "static/img/master-2.c8a4ed09.png";